export { default } from './MDLabel';
